import { Link } from "react-router-dom";
import {
  LoadingListCards,
  ListIconWrapper,
  BodyContainer,
  MainButton,
  ListCard,
  RightMainContainer,
  HeaderContainer,
  PrimaryHeading,
  TemplateNotFound,
  Loader,
} from "commonUI";
import { AddIcon, PriorityIcon } from "allIcons";
import { useDeletePriority, usePriority } from "hooks/priority";
import { useSearch } from "helpers";
import { useUserPermissions } from "hooks/user";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function PriorityTab() {
  const { web = null } = useSearch();
  const { isLoading, data: priorities } = usePriority();
  const deleteMutation = useDeletePriority();
  const {
    add_new_items_to_site_template,
    remove_items_from_site_template,
    edit_item_details_in_site_template,
  } = useUserPermissions();

  return (
    <>
      <RightMainContainer>
        <Loader show={deleteMutation.isLoading} loader="block" />
        <HeaderContainer>
          <PrimaryHeading>{t("siteSetting.priority.title")}</PrimaryHeading>
          {add_new_items_to_site_template ? (
            <Link to={`add${web ? `?web=${web}` : ""}`}>
              <MainButton>
                <AddIcon />
                {t("button.add")}
              </MainButton>
            </Link>
          ) : (
            ""
          )}
        </HeaderContainer>
        <BodyContainer>
          {isLoading ? (
            <LoadingListCards />
          ) : priorities.length === 0 ? (
            <TemplateNotFound
              label={t("siteSetting.priority.title")}
              linkLabel={t("siteSetting.priority.title")}
              link={
                add_new_items_to_site_template
                  ? `add${web ? `?web=${web}` : ""}`
                  : ""
              }
            />
          ) : (
            priorities.map((iner, index) => {
              return (
                <ListCard
                  data={iner.priority_title}
                  key={index}
                  index={index}
                  link={
                    edit_item_details_in_site_template
                      ? `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/priority/${iner.id}`
                      : ""
                  }
                  strictLink={true}
                  editIcon={edit_item_details_in_site_template}
                  deleteIcon={!web || !remove_items_from_site_template}
                  crossIcon={!web && remove_items_from_site_template}
                  onDelete={() => {
                    deleteMutation.mutate({
                      id: iner.id,
                      website_id: web,
                    });
                  }}
                  showModalonCross
                  icon={
                    <ListIconWrapper>
                      <PriorityIcon />
                    </ListIconWrapper>
                  }
                  deleteButtonText={web ? t("common.popup.button.confirmDelete") : t("common.deleteButton.title")}
                  deleteTitle={
                    web ? t("siteSetting.priority.confirmDelete.forSite.title") : t("siteSetting.priority.confirmDelete.title")
                  }
                  deleteMessage={
                    web
                    ? t("siteSetting.priority.confirmDelete.forSite.message")
                      : t("siteSetting.priority.confirmDelete.message")
                  }
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
